// src/Components/logistics/CityEditModal.jsx
import { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  InputGroup,
  InputGroupText,
  Row,
  Col,
} from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { NumericFormat } from "react-number-format";
import { toast } from "react-toastify";

export const CityEditModal = ({ city, isModalOpen, toggleModal, handleSaveEdit, currency }) => {
  const [shippingValue, setShippingValue] = useState("");

  useEffect(() => {
    if (city) {
      setShippingValue(city.shippingCost ?? "");
    }
  }, [city]);

  const handleSave = () => {    
    if (!shippingValue) {
      toast.error("Ingresa un costo de envío");
      return;
    }
    handleSaveEdit(Number(shippingValue));
  };

  if (!city) return null;

  return (
    <Modal
      isOpen={isModalOpen}
      toggle={toggleModal}
      size="md"
      centered
      backdrop="static"
      keyboard={false}
    >
      <ModalHeader toggle={toggleModal}>
        Editar costo de envío: <strong>{city.name}</strong>
      </ModalHeader>

      <ModalBody>
        <Row>
          <Col md="12">
            <Label>Costo de envío</Label>
            <InputGroup>
              <NumericFormat
                className="form-control"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale
                allowNegative={false}
                value={shippingValue}
                onValueChange={(values) => setShippingValue(values.value)}
                placeholder="Ej: 5.000"
              />
              <InputGroupText>{currency || "$"}</InputGroupText>
            </InputGroup>
          </Col>
        </Row>
      </ModalBody>

      <ModalFooter>
        <Btn attrBtn={{ color: "primary", onClick: handleSave }}>Guardar</Btn>
        <Btn attrBtn={{ color: "secondary", onClick: toggleModal }}>Cerrar</Btn>
      </ModalFooter>
    </Modal>
  );
};
